export const DARK_MODE_TOGGLE = "DARK_MODE_TOGGLE";
export const SIDE_NAV_TOGGLE = "SIDE_NAV_TOGGLE";
export const SET_IS_MOBILE = "SET_IS_MOBILE";
export const SET_EXPANDED = "SET_EXPANDED";
export const SET_MESSAGES_ACTIVE = "SET_MESSAGES_ACTIVE";
